import { GetterTree } from "vuex";
import { CrudState } from "@/store/Crud/State";
import { ArchiveState } from "@/store/Crud/functions/archived/State";

export const getArchiveSuccess = (state: ArchiveState) => state.archiveSuccess;

export default <GetterTree<ArchiveState, any>>{
  getArchiveSuccess,
};
